import { jsx as c, jsxs as f } from "react/jsx-runtime";
import { useRef as x, useEffect as O, createContext as I, useContext as b } from "react";
import { drawerBlueprint as v } from "./index-blueprint.es.js";
import { Drawer as o } from "vaul";
import y from "clsx";
import { useOverlayState as p } from "@made-people/blueprint-overlay";
import { Heading as R } from "@made-people/blueprint-heading";
import "@made-people/blueprint";
function T(t, l) {
  const a = x(!1);
  O(() => {
    t && a.current && l === !1 && document.querySelectorAll("[data-vaul-drawer]").forEach((n) => {
      var i;
      (i = n.style.transform) != null && i.includes("scale(") && !n.style.transform.includes("scale(1)") && (n.style.transition = "transform 0.5s cubic-bezier(0.32, 0.72, 0, 1)", n.style.transform = "scale(1) translate3d(0, 0, 0)");
    }), a.current = l === !0;
  }, [l, t]);
}
const D = I({
  hasOverlay: !0,
  hasHandle: !0,
  direction: "bottom"
}), h = ({
  variants: t,
  hasOverlay: l = !0,
  hasHandle: a = !0,
  hasScaledBackground: u = !0,
  setBackgroundColorOnScale: n = !1,
  children: i,
  direction: m = "bottom",
  header: C,
  repositionInputs: e,
  nested: s,
  ...r
}) => {
  const w = p(r.customOverlayId), d = w.isOpen ?? r.open;
  O(() => {
    r.defaultOpen && w.onChange(!0);
  }, []), O(() => {
    var N;
    typeof d == "boolean" && ((N = r.onOpenChange) == null || N.call(r, d));
  }, [d, r.onOpenChange]), T(s, d);
  const g = s ? o.NestedRoot : o.Root;
  return /* @__PURE__ */ c(
    D.Provider,
    {
      value: { direction: m, variants: t, hasOverlay: l, hasHandle: a, header: C, nested: s },
      children: /* @__PURE__ */ c(
        g,
        {
          ...r,
          repositionInputs: e,
          open: d,
          onOpenChange: w.onChange,
          shouldScaleBackground: s ? !1 : u,
          setBackgroundColorOnScale: s ? !1 : n,
          direction: m,
          children: i
        }
      )
    }
  );
};
function H({
  children: t,
  overlaySettings: l,
  contentSettings: a,
  portalSettings: u
}) {
  const { variants: n, hasOverlay: i, hasHandle: m, direction: C, header: e, nested: s } = b(D), r = v.styles({
    ...n,
    direction: (n == null ? void 0 : n.direction) ?? C
  });
  return /* @__PURE__ */ f(o.Portal, { ...u, children: [
    i && /* @__PURE__ */ c(
      o.Overlay,
      {
        ...l,
        className: y(
          r.overlay,
          s && "z-[90]",
          l == null ? void 0 : l.className
        )
      }
    ),
    /* @__PURE__ */ c(o.Title, { hidden: !0, children: "Drawer" }),
    /* @__PURE__ */ f(o.Description, { hidden: !0, children: [
      " ",
      (a == null ? void 0 : a["aria-description"]) ?? "Drawer"
    ] }),
    /* @__PURE__ */ f(
      o.Content,
      {
        "aria-description": "Content for drawer",
        tabIndex: -1,
        ...a,
        className: y(
          r.content,
          s && "z-[91]",
          "focus:outline-none",
          a == null ? void 0 : a.className
        ),
        children: [
          m && /* @__PURE__ */ c("div", { className: r.dragHandle }),
          e != null && e.headingSettings && (e != null && e.headingSettings.badge || e.headingSettings.heading) ? /* @__PURE__ */ f("div", { className: r.header, children: [
            /* @__PURE__ */ c(R, { ...e.headingSettings }),
            e.closeIcon && /* @__PURE__ */ c(o.Close, { className: r.headerCloseIcon, children: e.closeIcon })
          ] }) : (e == null ? void 0 : e.closeIcon) && /* @__PURE__ */ c(o.Close, { className: r.closeIcon, children: e.closeIcon }),
          t
        ]
      }
    )
  ] });
}
h.Trigger = o.Trigger;
h.Close = o.Close;
h.Title = o.Title;
h.Content = H;
export {
  h as Drawer,
  T as useNestedDrawerCleanup
};
//# sourceMappingURL=index.es.js.map
